import { defaultLocales } from './constants'
import { SchemaMappingFunctionDefinition } from './SchemaDefinition'
import { MappingFunctionDefinition } from './TypedDefinition'
import { MappingFunctionNode } from './TypedNode'

import type { PluginVisitors, RehajePlugin } from '@rehaje/core'

export interface MappingFunctionPluginProps {
  /**
   * 行序号变量名，默认为 `i`
   */
  indexName?: string
  /**
   * 行数据变量名，默认为 `item`
   */
  itemName?: string
  /**
   * 多语言设置
   *
   * @default
   * const defaultLocales = {
   *   item: '当前行数据',
   *   index: '当前行序号',
   *   rollup: '父级行数据'
   * }
   */
  locales?: {
    [K in keyof typeof defaultLocales]?: string
  }
  /**
   * 父级行数据变量名，默认为 `rollup`
   */
  rollupName?: string
}

/**
 * 循环映射函数插件
 */
export class MappingFunctionPlugin implements RehajePlugin {
  props: MappingFunctionPluginProps
  visitors: PluginVisitors = {
    definitions: {
      MappingFunction: MappingFunctionDefinition,
      'Schema.MappingFunction': SchemaMappingFunctionDefinition
    },
    nodes: {
      MappingFunction: MappingFunctionNode,
      /**
       * @deprecated
       */
      RepeatSlotFunction: MappingFunctionNode
    }
  }

  constructor(props?: MappingFunctionPluginProps) {
    this.props = {
      indexName: 'i',
      itemName: 'item',
      rollupName: 'rollup',
      ...props,
      locales: {
        ...defaultLocales,
        ...props?.locales
      }
    }
  }
}
